<template>
	<div data-component="link-preview">
		<component
			:is="getLinkComponent"
			data-element="link-info"
			v-bind="getLinkProps"
		>
			<tooltip
				:text="getStateText"
				position="top"
			>
				<icon
					v-if="getEnabled"
					data-element="state-icon"
					icon="check"
					colour="green"
					size="xs"
				/>
				<icon
					v-else
					data-element="state-icon"
					icon="cross-circle"
					colour="red"
					size="xs"
				/>
			</tooltip>
			<p data-element="name">
				{{ getName }}
			</p>
		</component>

		<v2-button
			type="text"
			fit
			size="sm"
			:variant="getCanCopy ? 'filled' : 'red'"
			:disabled="getExpired"
			data-element="copy-button"
			@click="copyLink">
			{{ getCanCopy ? 'Copy' : 'Expired' }}
			<icon v-if="getCanCopy" icon="v2-copy" colour="transparent" />
		</v2-button>
	</div>
</template>

<script>

	import V2Button from '@/components/v2/ui/V2Button.vue';
	import Icon from '@/components/ui/Icon';
	import Tooltip from '@/components/ui/Tooltip';

	export default {
		components: {
			V2Button,
			Icon,
			Tooltip
		},
		mixins: [],
		props: {
			link: {
				type: Object,
				required: true
			}
		},
		data: () => ({
			previewIsVisible: false
		}),
		computed: {
			getLinkComponent () {
				return 'router-link';
			},
			getLinkProps () {
				if (this.link) {
					return {
						to: `/teaching/links/${this.link.id}`
					};
				}
				return {};
			},
			getLinkUrl () {
				if (this.link) {
					return `${process.env.VUE_APP_HANDLE_URL}/deal/${this.link?.token}`;
				}
				return null;
			},
			getName () {
				return this.link?.name || '';
			},
			getEnabled () {
				return this.link?.enabled || false;
			},
			getStateText () {
				return `${this.getEnabled ? 'Enabled' : 'Disabled'} link`;
			},
			getExpirationDate () {
				const expirationDate = this.link?.expirationDate;
				if (expirationDate === null) {
					return '';
				}
				return expirationDate ? this.$store.getters['auth/getTimeInFormat']({
					time: expirationDate,
					format: 'DD.MM.YYYY, HH:mm'
				}) : '';
			},
			getExpired () {
				const expirationDate = this.link?.expirationDate;
				if (!expirationDate) {
					return false;
				}
				return this.$store.getters['auth/getTimeIsPast']({
					time: expirationDate
				});
			},
			getCanCopy () {
				return !this.getExpired;
			},
			getAccessibleBy () {
				return this.link?.accessibleBy;
			}
		},
		methods: {
			async copyLink () {
				if (this.getLinkUrl) {
					await navigator.clipboard?.writeText(this.getLinkUrl);
					this.$store.commit('ui/showNotification', {
						notification: 'Successfully copied'
					});
				}
			}
		}
	};

</script>

<style lang="scss" scoped>

	[data-component='link-preview'] {
		display: flex;
		align-items: center;
		width: 100%;

		font-size: rem(16);
		line-height: 1;
		margin-bottom: rem(8);

    padding: 16px;
    border-radius:4px;
    background-color: $c-gray-l2;
    @include font(18px, $c-dark-navy, 400, 23px);

		[data-element='state-icon'] {
			flex-shrink: 0;
			width: rem(28);
			height: rem(28);
			margin-right: rem(14);
		}

		[data-element='link-info'] {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			margin: 0;

			[data-element='name'] {
        margin-right: rem(24);
        @include font(18px, $c-dark-navy, 500, 20px);
        @include text-overflow;
        width: 100%;
			}
		}

		[data-element='expiration-date'] {
			margin-right: rem(24);
			margin-left: auto;
			@include font(14px, $c-dark-navy, 400, 18px);
			width: fit-content;
			white-space: nowrap;
		}

		.btn {
			flex-shrink: 0;
			margin: 0 0 0 auto;

			[data-component='icon'] {
				margin-left: 6px;
			}
		}
	}

</style>
